import React from 'react'
import DownloadReturns from './DownloadReturns'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { CreateButton } from '../../../../../Components/Utils/Buttons'

function PdfLinkReturns({headers,data,fileName}) {
    return (
        <PDFDownloadLink document={<DownloadReturns header={headers} data={data} />} fileName={fileName}>
        {({ blob, url, loading, error }) =>
          loading ? (
            "..."
          ) : (
            <CreateButton svg={false} label="Download as PDF" />
          )
        }
      </PDFDownloadLink>
      )
    }

export default PdfLinkReturns